import Vue from 'vue'
import onMount from '@/directives/onMount'
import vBadge from '@/directives/v-badge'
import imgHandler from '@/directives/imgHandler'
import tooltip from '@/directives/tooltip'

Vue.directive('onmount', onMount)
Vue.directive('badge', vBadge)
Vue.directive('img-handler', imgHandler)
Vue.directive('tooltip', tooltip)
